export default (store) => ({
  path : '/promo_codes',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'promo_codes' */
      './components/PromoCodesView'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
